<template>
  <div class="place-page">
    <!-- PC端 -->
    <div class="fakeSel" v-if="isPC">
      <van-field
        v-model="result"
        name="picker"
        label="日期选择"
        placeholder="请选择"
        class="selItem"
      />
      <select v-model="result">
        <option value="" disabled>请选择</option>
        <option
          v-for="(item, index) in columns"
          :key="index"
          :value="item.value"
        >
          {{ item.text }}
        </option>
      </select>
    </div>
    <!-- 移动端 -->
    <van-field
      v-if="!isPC"
      v-model="result"
      is-link
      readonly
      name="picker"
      label="日期选择"
      placeholder="请选择"
      @click="showPicker = true"
    />
    <van-popup v-if="!isPC" v-model:show="showPicker" destroy-on-close position="bottom">
      <van-picker
        :columns="columns"
        :model-value="pickerValue"
        @confirm="onConfirm"
        @cancel="showPicker = false"
      />
    </van-popup>
    <div class="place-img">
      <!-- 图片展示 -->
      <img :src="currentImg" @click="previewImg" />
    </div>
    <!-- 图片预览 -->
    <div
      class="preview-img-mask"
      v-if="showPreview"
      @click="showPreview = false"
    >
      <div>
        <img :src="preImg" alt="" />
      </div>
    </div>
    <!-- 按钮 -->
    <div style="margin: 16px; display: flex; justify-content: center; gap: 4vw">
      <van-button
        :color="mainColor"
        plain
        style="width: 24vw"
        type="primary"
        @click="router.go(-1)"
      >
        返回
      </van-button>
      <van-button
        :color="mainColor"
        style="width: 24vw"
        type="primary"
        native-type="submit"
      >
        一键官网
      </van-button>
    </div>
  </div>
</template>
<script setup>
import { ref, computed } from 'vue'
import place25 from '@/assets/place25.jpg'
import place26 from '@/assets/place26.jpg'
import place27 from '@/assets/place27.jpg'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
const router = useRouter()
const store = useStore()

const mainColor = computed(() => store.state.mainColor)
const isPC = computed(() => store.state.isPC)

const placeImgMap = {
  '2026-03-25': place25,
  '2026-03-26': place26,
  '2026-03-27': place27
}

const result = ref('2026-03-25')
const currentImg = computed(() => placeImgMap[result.value] || place25)
const pickerValue = ref([])
const showPicker = ref(false)
const columns = [
  { text: '2026-03-25', value: '2026-03-25' },
  { text: '2026-03-26', value: '2026-03-26' },
  { text: '2026-03-27', value: '2026-03-27' }
]

const onConfirm = ({ selectedValues, selectedOptions }) => {
  result.value = selectedOptions[0]?.text
  pickerValue.value = selectedValues
  showPicker.value = false
}
// 图片预览
const preImg = ref('')
const showPreview = ref(false)
const previewImg = () => {
  showPreview.value = true
  preImg.value = currentImg.value
}
</script>
<style lang="less" scoped>
.place-page {
  .fakeSel {
    position: relative;
    select {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      cursor: pointer;
    }
  }
  .place-img {
    padding: 3vw 5vw;
    img {
      width: 100%;
    }
  }
}
@media screen and (min-width: 768px) {
  .place-page .fakeSel {
    display: flex;
    align-items: center;
    padding: 10px 16px;
    background: #fff;
    .van-field {
      flex: 0 0 auto;
      width: auto;
      padding: 0;
      margin-right: 12px;
    }
    select {
      position: static;
      opacity: 1;
      flex: 1;
      padding: 8px 10px;
      border: 1px solid #666;
      border-radius: 6px;
      font-size: 14px;
      background: #fff;
      cursor: pointer;
      height: auto;
      width: auto;
    }
  }
}
.preview-img-mask {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.9);
  z-index: 999;
  display: flex;
  flex-direction: column;
  justify-content: center;
  img {
    width: 100%;
  }
}
</style>